import React from "react";
import PropTypes from "prop-types";
import ChangeShippingAddress from "components/source/shared/shipping_addresses/ChangeShippingAddress";
import { ChangeAddressModalNames } from "rtr-constants";

const modalName = ChangeAddressModalNames.changeAddressFromGrid;

export default class GridTopFiltersAddressModal extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  };

  static modalName = modalName;

  render() {
    const { onChange } = this.props;

    return (
      <ChangeShippingAddress
        addressBookTitle="Where will we be shipping?"
        addressBookDek="We'll show you available styles in that location."
        modalName={modalName}
        onChange={onChange}
      />
    );
  }
}
